import NavigationBreadcrumbs from './NavigationBreadcrumbs';

export { type NavigationBreadcrumbsProps } from './NavigationBreadcrumbs';
export default NavigationBreadcrumbs;
